export default __webpack_public_path__ + "static/media/pic7.4fd6f84d.png";